var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2305 1.17578C26.9629 1.9082 26.9629 3.09766 26.2305 3.83008L11.2305 18.8301C10.498 19.5625 9.30859 19.5625 8.57617 18.8301L1.07617 11.3301C0.34375 10.5977 0.34375 9.4082 1.07617 8.67578C1.80859 7.94336 2.99805 7.94336 3.73047 8.67578L9.90625 14.8457L23.582 1.17578C24.3145 0.443359 25.5039 0.443359 26.2363 1.17578H26.2305Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLCheckIcon);
export default __webpack_public_path__ + "static/media/l_check_icon.9795c5848dc266f60dfc0eb94bb8f3e3.svg";
export { ForwardRef as ReactComponent };